module.exports = __webpack_public_path__ + "static/media/1920.1edf080d.webp";